import { all, call, put, takeEvery } from "redux-saga/effects";
import * as actions from "../slices/planSlice";

import planApis from "src/api/plan";

import { common } from "src/types/index";
import { constants } from "src/constants/common";

// create plan saga
const CreatePlanSaga = function* CreatePlanSaga({
  payload,
}: ReturnType<typeof actions.createPlanRequest> & { payload: any }) {
  try {
    const response: common.ResponseGenerator = yield call(
      planApis.createPlan,
      payload
    );

    yield put(actions.createPlanSuccess(response));
  } catch (error) {
    yield put(
      actions.createPlanError(
        error instanceof Error
          ? error?.message
          : constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG
      )
    );
  }
};

// edit plan saga
const EditPlanSaga = function* EditPlanSaga({
  payload,
}: ReturnType<typeof actions.editPlanRequest> & { payload: any }) {
  try {
    const response: common.ResponseGenerator = yield call(
      planApis.editPlan,
      payload
    );

    yield put(actions.editPlanSuccess(response));
  } catch (error) {
    yield put(
      actions.editPlanError(
        error instanceof Error
          ? error?.message
          : constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG
      )
    );
  }
};

// get plan list saga
const GetPlanListSaga = function* GetPlanListSaga({
  payload,
}: ReturnType<typeof actions.getPlanListRequest> & {
  payload: { page: number; limit: number };
}) {
  try {
    const response: common.ResponseGenerator = yield call(
      planApis.getPlanList,
      payload
    );

    yield put(actions.getPlanListSuccess(response));
  } catch (error) {
    yield put(
      actions.getPlanListError(
        error instanceof Error
          ? error?.message
          : constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG
      )
    );
  }
};

// get plan details saga
const GetPlanDetailsSaga = function* GetPlanDetailsSaga({
  payload,
}: ReturnType<typeof actions.getPlanDetailsRequest> & { payload: string }) {
  try {
    const response: common.ResponseGenerator = yield call(
      planApis.getPlanDetails,
      payload
    );

    yield put(actions.getPlanDetailsSuccess(response));
  } catch (error) {
    yield put(
      actions.getPlanDetailsError(
        error instanceof Error
          ? error?.message
          : constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG
      )
    );
  }
};

export default function* tenantSaga() {
  yield all([takeEvery(actions.createPlanRequest, CreatePlanSaga)]);
  yield all([takeEvery(actions.editPlanRequest, EditPlanSaga)]);
  yield all([takeEvery(actions.getPlanListRequest, GetPlanListSaga)]);
  yield all([takeEvery(actions.getPlanDetailsRequest, GetPlanDetailsSaga)]);
}
